import { seoContent } from '@/mocks/content';

export default function AboutSection() {
  return (
    <section id="sobre" className="relative w-full py-20 md:py-28 bg-secondary-50">
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-20">
          <div className="lg:w-1/3">
            <span className="text-xs md:text-sm font-medium text-foreground-500 uppercase tracking-wider">
              {seoContent.aboutTag}
            </span>
            <div className="mt-8 grid grid-cols-2 gap-3">
              <div className="relative w-full h-40 md:h-48 rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Organized%20spreadsheet%20closeup%20on%20modern%20laptop%20screen%20with%20product%20listings%20clearly%20visible%2C%20warm%20workspace%20lighting%2C%20minimal%20desk%20setup%2C%20cream%20and%20beige%20aesthetic%2C%20professional%20editorial%20photography%2C%20soft%20shadows%2C%20clean%20composition&width=300&height=400&seq=about-img-a1&orientation=landscape"
                  alt="Planilha CSSBuy organizada"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="relative w-full h-40 md:h-48 rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Fashion%20products%20showing%20price%20comparison%20concept%2C%20two%20similar%20items%20side%20by%20side%20on%20cream%20background%2C%20soft%20natural%20lighting%2C%20minimal%20product%20photography%2C%20warm%20neutral%20tones%2C%20clean%20editorial%20style%2C%20savings%20concept%20visual&width=300&height=400&seq=about-img-a2&orientation=landscape"
                  alt="Comparação de preços CSSBuy"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="relative w-full h-40 md:h-48 rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Community%20of%20shoppers%20concept%2C%20diverse%20group%20of%20people%20avatars%20around%20laptop%20displaying%20spreadsheet%2C%20warm%20friendly%20aesthetic%2C%20cream%20background%2C%20soft%20lighting%2C%20editorial%20photography%2C%20collaboration%20theme%2C%20minimal%20composition&width=300&height=400&seq=about-img-a3&orientation=landscape"
                  alt="Comunidade CSSBuySpreadsheet"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
              <div className="relative w-full h-40 md:h-48 rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Weekly%20update%20calendar%20and%20checklist%20concept%20on%20minimal%20desk%2C%20refreshed%20spreadsheet%20icon%2C%20warm%20morning%20light%2C%20cream%20and%20beige%20palette%2C%20clean%20organized%20aesthetic%2C%20editorial%20photography%2C%20fresh%20start%20symbolism&width=300&height=400&seq=about-img-a4&orientation=landscape"
                  alt="Atualização semanal CSSBuySpreadsheet"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
          <div className="lg:w-2/3">
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-medium text-foreground-900 leading-relaxed mb-10">
              {seoContent.aboutTitle}
            </h2>
            <div className="space-y-6">
              {seoContent.aboutParagraphs.map((para, idx) => (
                <p key={idx} className="text-foreground-700 text-sm md:text-base leading-relaxed">
                  {para}
                </p>
              ))}
            </div>
            <div className="flex items-center gap-6 mt-10 pt-8 border-t border-secondary-300/50">
              <span className="text-xs text-foreground-500 whitespace-nowrap">
                • {seoContent.aboutUpdate}
              </span>
              <div className="flex -space-x-3">
                {[1, 2, 3, 4].map((i) => (
                  <div
                    key={i}
                    className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-secondary-400 border-2 border-secondary-50 flex items-center justify-center overflow-hidden"
                  >
                    <i className="ri-user-line text-secondary-700 text-sm"></i>
                  </div>
                ))}
              </div>
              <span className="text-xs text-foreground-500">
                +2.000 usuários ativos
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}